import { Suspense } from 'react';
import { useLoaderData, json, defer, Await } from 'react-router-dom';

import ServicesList from '../components/ServicesList.jsx';

import backend from '../util/backend.jsx';

function ServicesSection() {
  const { services } = useLoaderData();

  //console.log(`ServicesSection services: ${services}`);

  return (
    <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
      <Await resolve={services}>
        {(loadedServices) => <ServicesList services={loadedServices} />}
      </Await>
    </Suspense>
  );
}

export {ServicesSection};

export async function loadServices(id) {
  const response = await fetch(`https://${backend}/services?id=${id}`);

  if (!response.ok) {
    throw json(
      { message: 'Could not fetch services for {id}.' },
      {
        status: 500,
      }
    );
  } else {
    const resData = await response.json();
    //console.log(`services: ${resData}`);
    return resData;
  }
}

export async function servicesLoader({ request, params }) {
  const id = params.vendorId;

  console.log(`servicesLoader id: ${id}`);

  return defer({
    services: loadServices(id),
  });
}
